/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BillingAccountData } from './BillingAccountData';
import {
    instanceOfBillingAccountData,
    BillingAccountDataFromJSON,
    BillingAccountDataFromJSONTyped,
    BillingAccountDataToJSON,
} from './BillingAccountData';

/**
 * @type ProjectDataBillingAccount
 * 
 * @export
 */
export type ProjectDataBillingAccount = BillingAccountData;

export function ProjectDataBillingAccountFromJSON(json: any): ProjectDataBillingAccount {
    return ProjectDataBillingAccountFromJSONTyped(json, false);
}

export function ProjectDataBillingAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDataBillingAccount {
    if (json == null) {
        return json;
    }
    if (instanceOfBillingAccountData(json)) {
        return BillingAccountDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function ProjectDataBillingAccountToJSON(json: any): any {
    return ProjectDataBillingAccountToJSONTyped(json, false);
}

export function ProjectDataBillingAccountToJSONTyped(value?: ProjectDataBillingAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfBillingAccountData(value)) {
        return BillingAccountDataToJSON(value as BillingAccountData);
    }

    return {};
}

